import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import classnames from "classnames";
import AppLogo from "../../../AppDownload/AppLogo";
import AppRating from "../../../AppDownload/AppRating";
import useGetExperimentVariables from "../../../../utils/hooks/useGetExperimentVariables";
import { trackExperimentEvent } from "@src/client/analytics/optimizely";
import DownloadAppButton from "../../../AppDownload/DownloadButton";
import styles from "./index.css";

const FEATURE_KEY = "web_nav_app_download_banner";
const BANNER_TEXT_KEY = "banner_text_key";
const CTA_TEXT_KEY = "cta_text_key";
const DOWNLOAD_APP_CLICK_EVENT = "download_app_click";
const CTA_REF = "secondary-nav|app download|our apps";
const VARIABLE_KEYS = [BANNER_TEXT_KEY, CTA_TEXT_KEY];

const AppDownloadBanner = ({ formatTranslation, defaultStoreUrl }) => {
  const { [BANNER_TEXT_KEY]: bannerTextKey, [CTA_TEXT_KEY]: ctaTextKey } =
    useGetExperimentVariables({
      featureKey: FEATURE_KEY,
      variableKeys: VARIABLE_KEYS
    });

  return (
    <section
      className={classnames(styles.container)}
      data-testid="app-download-banner"
    >
      <div className={styles.copyContainer}>
        <AppLogo classes={styles.navAppLogo} />
        <div className={styles.textContainer}>
          <AppRating darkStars />
          <p className={styles.bannerText}>
            {formatTranslation(
              bannerTextKey || "secondary_navigation_app_download_banner_text"
            )}
          </p>
        </div>
      </div>
      <DownloadAppButton
        ctaRef={CTA_REF}
        defaultStoreUrl={defaultStoreUrl}
        trackingCallback={() =>
          trackExperimentEvent(DOWNLOAD_APP_CLICK_EVENT, { ctaref: CTA_REF })
        }
        classes={styles.ctaButton}
        theme="primary"
      >
        {formatTranslation(
          ctaTextKey || "secondary_navigation_app_download_banner_cta"
        )}
      </DownloadAppButton>
    </section>
  );
};

AppDownloadBanner.propTypes = {
  formatTranslation: PropTypes.func,
  defaultStoreUrl: PropTypes.string.isRequired
};

export default withTranslation(AppDownloadBanner);
